import React, { useState } from "react";
import {Link} from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faMinusCircle, faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { library as fontAwesomeLibrary } from "@fortawesome/fontawesome-svg-core";

fontAwesomeLibrary.add(faPlusCircle, faMinusCircle, faUpRightFromSquare);

const TreeNode = ({ node, level }) => {
  const [collapsed, setCollapsed] = useState(true);
  const hasChildren = node.children.length > 0;

  let shortName = node.shortName && !node.name.replace("-"," ").includes(node.shortName) && !node.hcutId.includes(node.shortName)
                  ?
                  node.shortName :  null;

  if (level === 0) {
    // Top level: table rows
    return (
      <React.Fragment key={node.hcutId}>
        <tr className="missionListTableRow">
          <td className="missionListTableCell">
            {!node.noLink || node.noLink === false
              ?
              (<Link to={`/mission/${node.hcutId}`}>{node.hcutId}</Link>)
              : (<span>{node.hcutId}</span>)
            }
              {hasChildren && (
              <button
                onClick={() => setCollapsed(!collapsed)}
                className="expandButton expandButtonID"
                aria-label={collapsed ? "Expand" : "Collapse"}
              >
                <FontAwesomeIcon icon={collapsed ? faPlusCircle : faMinusCircle} />
              </button>
            )}
          </td>
          <td className="missionListTableCell missionTableName">
            {!node.noLink || node.noLink === false
              ?
              <>
                <Link to={`/mission/${node.hcutId}`}>
                  {`${node.name} ${shortName ? '(' + shortName + ')' : ""}`}
                </Link>
                <> </>
                <a
                  href={`${window.location.origin}/mission/${node.hcutId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon
                    style={{ fontSize: "11px", marginLeft: "4px" }}
                    icon={faUpRightFromSquare}
                  />
                </a>
              </>
              :
              <span>{`${node.name} ${shortName ? '(' + shortName +')': ""}`}</span>
            }
            {hasChildren && (
              <button
                onClick={() => setCollapsed(!collapsed)}
                className="expandButton expandButtonName"
                aria-label={collapsed ? "Expand" : "Collapse"}
              >
                <FontAwesomeIcon icon={collapsed ? faPlusCircle : faMinusCircle} />
              </button>
            )}
          </td>
        </tr>
        {hasChildren && !collapsed && (
          <tr className="missionListTableNestedRow">
            <td colSpan={2}>
              <Tree nodes={node.children} level={level + 1} />
            </td>
          </tr>
        )}
      </React.Fragment>
    );
  }

  // Nested levels: lists
  return (
    <li>
      {hasChildren && (
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="expandButton"
          aria-label={collapsed ? "Expand" : "Collapse"}
        >
          <FontAwesomeIcon icon={collapsed ? faPlusCircle : faMinusCircle} />
        </button>
      )}
      <Link to={`/mission/${node.hcutId}`}>
        {`${node.hcutId.replace("Ground_","").replace("_", " ")} ${node.name !== node.hcutId.replace("Ground_","").replace("_", " ") ? '(' + node.name + ')' : ""}`}
      </Link>
      <a
        href={`${window.location.origin}/mission/${node.hcutId}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <FontAwesomeIcon
          style={{ fontSize: "11px", marginLeft: "4px" }}
          icon={faUpRightFromSquare}
        />
      </a>
      {hasChildren && !collapsed && (
        <Tree nodes={node.children} level={level + 1} />
      )}
    </li>
  );
};

const Tree = ({ nodes, level = 0 }) => {
  if (!nodes) return null;

  if (level === 0) {
    return (
      <tbody>
        {nodes.map(node => (
          <TreeNode key={node.hcutId} node={node} level={level} />
        ))}
      </tbody>
    );
  }

  return (
    <ul className="nestedList">
      {nodes.map(node => (
        <TreeNode key={node.hcutId} node={node} level={level} />
      ))}
    </ul>
  );
};


export function MissionListTable(props) {
  const { groupedData } = props;

  return (
    <table className="missionListTable">
      <thead>
        <tr>
          <th className="missionListTableHeader missionListTableHeaderId">ID</th>
          <th className="missionListTableHeader missionListTableHeaderName">Name</th>
        </tr>
      </thead>
      <Tree nodes={groupedData} />
    </table>
  );
}
